import { AxiosError } from 'axios';
import instance from '../config/axios';

export async function previewAndDownloadCSV(
  token: string,
  taskExecutionId: string,
) {
  try {
    const response = await instance({
      method: 'POST',
      url: `/api/v1/bulk-email/download/csv`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: { taskExecutionId },
      responseType: 'blob',
    });

    if (response.status !== 200) {
      return response.status;
    }

    return response.data;
  } catch (e) {
    console.log(e);
    return (e as AxiosError).response!.status;
  }
}
